<template>
  <section v-if="state.job || state.hold" ref="progress" tabindex="-1" class="bulk-progress w-100" :aria-label="$t(`${key}.progress`)">
    <v-alert v-if="state.error" type="warning" role="status">
      {{ $t(`${key}.${state.error}`) }}
      <v-btn v-if="state.error === 'statusError'" variant="text" @click="$emit('retry')">{{ $t('ncrm.contacts.dataProtection.record.retry') }}</v-btn>
    </v-alert>
    <template v-if="state.job">
      <p>{{ $t(`${key}.context`, { ...state.context, doi: $t(`app.labels.${state.context.doi_after_accept ? 'yes' : 'no'}`) }) }}</p>
      <p role="status" class="mb-2">{{ $t(`${key}.${state.job.status}`, state.job) }}</p>
      <v-progress-linear :model-value="state.job.total ? state.job.processed * 100 / state.job.total : 100"
        :aria-label="$t(`${key}.progress`)" />
      <p class="my-2">{{ $t(`${key}.results`, counts) }}</p>
      <p class="text-body-2">{{ $t(`${key}.tracking`) }}</p>
      <ul class="pl-5">
        <li v-for="(row, index) in state.job.rows" :key="index" class="my-2">
          <router-link :to="`/ncrm/${state.subjectType === 'person' ? 'people' : 'companies'}/${row.subject_id}`" target="_blank" rel="noopener">#{{ row.subject_id }}</router-link>
          · {{ $t(`${key}.outcomes.${row.outcome}`) }}
          <span v-if="row.contact_point_id"> · {{ $t(`${key}.point`, { id: row.contact_point_id }) }}</span>
          <span v-if="row.reason_code"> — {{ reason(row) }}</span>
          <span v-if="row.attempt_id"> · {{ $t('ncrm.contacts.dataProtection.record.invitation.attempt', { id: row.attempt_id }) }}</span>
        </li>
      </ul>
      <v-btn v-if="state.job.status === 'completed'" variant="text" @click="$emit('dismiss')">{{ $t('app.actions.close') }}</v-btn>
    </template>
    <p v-else-if="state.sending" role="status">{{ $t(`${key}.starting`) }}</p>
  </section>
</template>
<script>
import { invitationReasonText } from "@/Utile/ncrmPrivacyInvitationReasons.mjs";
export default {
  name: "NcrmPrivacyBulkProgress", props: { state: { type: Object, required: true } }, emits: ["retry", "dismiss"],
  computed: {
    key() { return "ncrm.contacts.dataProtection.bulkSend"; },
    counts() { return Object.fromEntries(["accepted", "not_sent", "rejected", "uncertain"].map(outcome =>
      [outcome, this.state.job.rows.filter(row => row.outcome === outcome).length])); },
  },
  methods: {
    focus() { this.$refs.progress?.focus({ preventScroll: true }); },
    reason(row) {
      if (["duplicate_email", "no_email"].includes(row.reason_code)) return this.$t(`ncrm.contacts.dataProtection.bulkPreview.${row.reason_code}`);
      if (["access_unavailable", "delivery_unconfirmed", "settlement_unconfirmed", "worker_unavailable", "scope_unavailable"].includes(row.reason_code))
        return this.$t(`${this.key}.${row.reason_code === 'access_unavailable' ? 'access' : row.outcome === 'uncertain' ? 'uncertain' : 'unavailable'}`);
      return invitationReasonText(this, row.reason_code);
    },
  },
};
</script>
<style scoped>
.bulk-progress { overflow-wrap: anywhere; }
.bulk-progress:focus-visible { outline: 2px solid rgb(var(--v-theme-primary)); outline-offset: 2px; }
</style>
